import {textSizes} from '@stencil/build-theme';
import styled from 'styled-components';

export const HotelTag = styled.div`
  display: flex;
  align-items: center;
  padding: 0.2rem 0.4rem;
  border: 0.1rem solid #e4e4e4;
  ${textSizes.SmallW1};
  color: #222;
  border-radius: 0.4rem;
`;

export const HotelStarRating = styled.div`
  display: flex;
  align-items: center;
`;

type PropertyLabelProps = {
  $isHotelStarRating?: boolean;
};

export const PropertyLabel = styled.span<PropertyLabelProps>`
  position: relative;
  margin-left: ${props => (props.$isHotelStarRating ? '0.6rem' : '0')};

  ${props =>
    props.$isHotelStarRating &&
    `&::before {
    content: '';
    position: absolute;
    width: 0.2rem; /* Width of the dot */
    height: 0.2rem; /* Height of the dot */
    background-color: black; /* Color of the dot */
    border-radius: 50%; /* Make it a circle */
    top: 50%;
    left: -0.4rem; /* Position the dot 0.4rem to the left */
    transform: translate(-50%, -50%); /* Center the dot */
  }`};
`;
